export default __webpack_public_path__ + "images/827263225d6d41ef3f8e2321c789b929.png";